/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import validate from 'validate.js';
import { withRouter } from 'react-router-dom';
import { Grid } from '@mui/material';
import moment from 'moment';
import * as Roles from '../../../constants/role';
import * as selectorsOdometros from '../../../store/odometro/reducer';
import * as actionsOdometros from '../../../store/odometro/actions';
import * as selectorsAuth from '../../../store/auth/reducer';
import {
  DatePickerV2,
  DialogDefaultV2,
  DropzoneV2,
  InputV2,
  TrueFalseSelectV2,
  UsuarioSelectV2,
  ValidateSelectV2,
  VeiculoSelectV2,
} from '../../../components/v2';

const schema = {
  odometroInicial: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  odometroFinal: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  veiculoId: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  inspecao: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  fotoInicialFile: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  fotoFinalFile: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  usuarioId: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
};

const Formulario = ({
  saveOdometro,
  updateOdometro,
  selectedOdometro,
  open,
  id,
  onClose,
  findOdometroById,
  isAdmin,
}) => {
  const [values, setValues] = useState({ data: moment().valueOf() });
  const [errors, setErrors] = useState({});
  const [fotoInicialFile, setFotoInicialFile] = useState(null);
  const [fotoFinalFile, setFotoFinalFile] = useState(null);
  const [readOnly, setReadOnly] = useState(false);

  useEffect(() => {
    if (id) findOdometroById(id);
  }, [id, findOdometroById]);

  useEffect(() => {
    if (id && selectedOdometro && id === selectedOdometro.id) {
      const fotoInicial = selectedOdometro.fotoInicialFile instanceof Blob
        ? selectedOdometro.fotoInicialFile
        : null;
      const fotoFinal = selectedOdometro.fotoFinalFile instanceof Blob
        ? selectedOdometro.fotoFinalFile
        : null;
      const nextValues = {
        ...selectedOdometro,
        data: selectedOdometro.data ? Number(selectedOdometro.data) : moment().valueOf(),
        fotoInicialFile: fotoInicial,
        fotoFinalFile: fotoFinal,
      };
      setFotoInicialFile(fotoInicial);
      setFotoFinalFile(fotoFinal);
      setValues(nextValues);
      setReadOnly(selectedOdometro.validate === 'VALIDADO' || selectedOdometro.validate === 'INVALIDADO');
    } else {
      setFotoInicialFile(null);
      setFotoFinalFile(null);
      setValues({ data: moment().valueOf() });
      setReadOnly(false);
    }
  }, [id, selectedOdometro]);

  const saveCallback = success => {
    if (success) {
      onCloseLocal(true);
    }
  };

  const onSave = () => {
    const erros = validate(values, schema);
    setErrors(erros);

    if (!erros && Number(values.odometroFinal) < Number(values.odometroInicial)) {
      setErrors({ odometroFinal: 'Odômetro final menor que inicial' });
    } else if (!erros) {
      const payload = {
        ...values,
        fotoInicial: {
          nome: values.fotoInicialFile.name.split('.')[0],
          extensao: values.fotoInicialFile.name.split('.').pop(),
          status: 'NOT_SYNC',
        },
        fotoFinal: {
          nome: values.fotoFinalFile.name.split('.')[0],
          extensao: values.fotoFinalFile.name.split('.').pop(),
          status: 'NOT_SYNC',
        },
      };

      if (values.id) updateOdometro(payload, saveCallback);
      else saveOdometro(payload, saveCallback);
    }
  };

  const onCloseLocal = isSave => {
    setErrors({});
    setValues({});
    setFotoInicialFile(null);
    setFotoFinalFile(null);
    onClose(isSave);
  };

  const handleChange = event => {
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  const calculateKmRodado = () =>
    values.odometroInicial && values.odometroFinal
      ? String(Number(values.odometroFinal) - Number(values.odometroInicial))
      : '';

  return (
    <DialogDefaultV2
      open={open}
      handlerCancel={() => onCloseLocal(false)}
      handlerConfirm={onSave}
      title="Odômetro"
      confirmMessage="Salvar"
      maxWidth="md"
      fullWidth
    >
      <Grid container spacing={1} sx={{ mt: 0 }}>
        <Grid size={{ xs: 12, sm: 6, md: 3 }} sx={{ pb: 0 }}>
          <VeiculoSelectV2
            isRequired
            onSelect={veiculoId => setValues({ ...values, veiculoId })}
            value={values.veiculoId}
            disabled={readOnly}
            error={!!(errors && errors.veiculoId)}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 3 }} sx={{ pb: 0 }}>
          <InputV2
            error={!!(errors && errors.odometroInicial)}
            helperText={errors && errors.odometroInicial ? errors.odometroInicial[0] || errors.odometroInicial : null}
            isRequired
            label="Km Inicial"
            name="odometroInicial"
            onChange={handleChange}
            value={values.odometroInicial || ''}
            disabled={readOnly}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 3 }} sx={{ pb: 0 }}>
          <InputV2
            error={!!(errors && errors.odometroFinal)}
            helperText={errors && errors.odometroFinal ? errors.odometroFinal[0] || errors.odometroFinal : null}
            isRequired
            label="Km Final"
            name="odometroFinal"
            onChange={handleChange}
            value={values.odometroFinal || ''}
            disabled={readOnly}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 3 }} sx={{ pb: 0 }}>
          <InputV2 label="Km Rodado" value={calculateKmRodado()} disabled />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 3 }} sx={{ pb: 0 }}>
          <DatePickerV2
            label="Data"
            onChange={data => setValues({ ...values, data })}
            value={values.data}
            disabled={readOnly}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 3 }} sx={{ pb: 0 }}>
          <InputV2 label="Data Inclusão" disabled value={values.dataInclusao || ''} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 3 }} sx={{ pb: 0 }}>
          <UsuarioSelectV2
            isRequired
            error={!!(errors && errors.usuarioId)}
            label="Inspetor"
            ativo
            grupos={[Roles.ADMIN, Roles.INSPETOR]}
            onSelect={usuarioId => setValues({ ...values, usuarioId })}
            value={values.usuarioId}
            disabled={readOnly}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 3 }} sx={{ pb: 0 }}>
          <UsuarioSelectV2
            label="Ajudante/Observador"
            ativo
            grupos={[Roles.ADMIN, Roles.INSPETOR]}
            onSelect={inspetorAuxiliar => setValues({ ...values, inspetorAuxiliar })}
            value={values.inspetorAuxiliar}
            disabled={readOnly}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 3 }} sx={{ pb: 0 }}>
          <TrueFalseSelectV2
            error={!!(errors && errors.inspecao)}
            isRequired
            label="É Inspeção"
            name="inspecao"
            onChange={handleChange}
            value={values.inspecao}
            disabled={readOnly}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 3 }} sx={{ pb: 0 }}>
          <ValidateSelectV2
            onChange={validateValue => setValues({ ...values, validate: validateValue })}
            value={values.validate}
            disabled={!isAdmin}
          />
        </Grid>
        <Grid size={{ xs: 12 }} sx={{ pb: 0 }}>
          <InputV2
            error={!!(errors && errors.justificativa)}
            label="Justificativa"
            name="justificativa"
            onChange={handleChange}
            value={values.justificativa || ''}
            rows={3}
            multiline
            disabled={readOnly}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }} sx={{ pb: 0 }}>
          <DropzoneV2
            buttonText="Foto Inicial"
            filesLimit={1}
            acceptedFiles={['.png', '.pdf', '.jpeg', '.jpg']}
            error={!!(errors && errors.fotoInicialFile)}
            onSave={files => {
              if (files != null && files.length > 0) {
                const file = files[0];
                setFotoInicialFile(file);
                setValues(prev => ({ ...prev, fotoInicialFile: file }));
              }
            }}
            disabled={readOnly}
            showGridFiles
            files={fotoInicialFile != null ? [{
              file: fotoInicialFile,
              nome: fotoInicialFile.name,
              onDelete: () => {
                setFotoInicialFile(null);
                setValues(prev => ({ ...prev, fotoInicialFile: null }));
              },
            }] : []}
            canDeleteFiles={!readOnly}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }} sx={{ pb: 0 }}>
          <DropzoneV2
            buttonText="Foto Final"
            filesLimit={1}
            acceptedFiles={['.png', '.pdf', '.jpeg', '.jpg']}
            error={!!(errors && errors.fotoFinalFile)}
            onSave={files => {
              if (files != null && files.length > 0) {
                const file = files[0];
                setFotoFinalFile(file);
                setValues(prev => ({ ...prev, fotoFinalFile: file }));
              }
            }}
            disabled={readOnly}
            showGridFiles
            files={fotoFinalFile != null ? [{
              file: fotoFinalFile,
              nome: fotoFinalFile.name,
              onDelete: () => {
                setFotoFinalFile(null);
                setValues(prev => ({ ...prev, fotoFinalFile: null }));
              },
            }] : []}
            canDeleteFiles={!readOnly}
          />
        </Grid>
      </Grid>
    </DialogDefaultV2>
  );
};

Formulario.propTypes = {
  findOdometroById: PropTypes.func.isRequired,
  saveOdometro: PropTypes.func.isRequired,
  updateOdometro: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  id: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  selectedOdometro: PropTypes.object,
  isAdmin: PropTypes.bool,
};

Formulario.defaultProps = {
  selectedOdometro: null,
  id: null,
  isAdmin: false,
};

const mapStateToProps = state => ({
  selectedOdometro: selectorsOdometros.getSelectedOdometro(state),
  authData: selectorsAuth.getAuth(state),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  ...actionsOdometros,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Formulario));
